import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetUniqueLocationsWithInventory } from '~/api/my-products';
import type { RootState } from '~/redux/store';
import { assignedLocations } from './branchSelection';

function useUserLocations() {
  return useSelector((state: RootState) => state.auth.user?.locations);
}

export function useAssignedLocations() {
  const userLocations = useUserLocations();
  return useMemo(() => userLocations ?? [], [userLocations]);
}

export function useAssignedLocationsWithInventory() {
  const { data } = useGetUniqueLocationsWithInventory();
  const userLocations = useUserLocations();
  return useMemo(
    () =>
      data && userLocations
        ? assignedLocations(data.uniqueLocationsWithInventory, userLocations)
        : undefined,
    [data, userLocations]
  );
}
